import { Store } from 'src/store/index';

const getOpenedDropdownMenu = (store: Store) => store.app.openedDropdownMenu;

export default getOpenedDropdownMenu;
